import { useScriptInjector } from '../useScriptInjector';

const NewRelic = () => {

  const isScriptDefer = false;
  const isAsync = true;

  useScriptInjector(
    `/thirdParty/newRelic.${process.env.REACT_APP_ENV}.min.js`,
    isAsync,
    isScriptDefer,
    "newrelic"
  );

  return null;
}

export default NewRelic;
